<template>
  <div v-if="row && detail">
    <p class="title-Individual-center">
      <span>招聘管理</span>
      <i class="el-icon-arrow-right"></i>
      <span>精英管理</span>
      <i class="el-icon-arrow-right"></i>
      <span @click="goBack" style="cursor: pointer">{{ row.name }}</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">{{ detail.username }}</span>
    </p>
    <div class="ResumeContent">
      <div class="box-top">
        <div class="left flex-box">
          <div class="left-img">
            <img :src="detail.userImg" alt="" />
          </div>
          <div class="left-text">
            <div style="margin-bottom: 20px">
              <span style="font-size: 20px; color: #333; font-weight: 400">{{
                detail.username
              }}</span>
              <span>{{ detail.sex == 1 ? "男" : "女" }}</span>
              <span>{{ detail.age }}岁</span>
              <span>{{ detail.xlName }}</span>
              <span>{{ detail.workYear }}年</span>
            </div>
            <div>
              <span>{{ detail.userJobIntentionList[0].addressName }}</span>
              <span>{{ detail.userJobIntentionList[0].positionName }}</span>
              <span>{{
                detail.userJobIntentionList[0].hopeMinSalary === 0 &&
                detail.userJobIntentionList[0].hopeMaxSalary === 0
                  ? "面议"
                  : detail.userJobIntentionList[0].hopeMinSalary / 1000 +
                    "k-" +
                    detail.userJobIntentionList[0].hopeMaxSalary / 1000 +
                    "k"
              }}</span>
              <span>{{ detail.userJobIntentionList[0].industryTypeName }}</span>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="right-button firm-clickable" @click="toggleCollect" >
            <img
              :src="
                isCollected
                  ? require('@/assets/imgs/shoucang@3x.svg')
                  : require('@/assets/imgs/shoucang-null@3x.svg')
              "
              alt=""
            />
            <span style="margin-left: 5px">{{
              isCollected ? "取消收藏" : "收藏"
            }}</span>
          </div>
          <div class="right-button firm-clickable" @click="goPj" v-if="detail.hasEvaluation">
            <img src="@/assets/imgs/fankui@3x.svg" alt="" />
            <span>信用评价</span>
          </div>
          <div class="right-button firm-clickable" v-if="!showNoResume" @click="onJb(item)">
            <img src="@/assets/imgs/jinggao.svg" alt="" />
            <span style="margin-left: 5px">举报</span>
          </div>
        </div>
      </div>
      <div class="text-content">
        <template v-if="showNoResume">
          <div class="no-resume-box">
            <img src="@/assets/imgs/no-jianli.png" alt="" class="work-icon" />
            <div class="no-resume-text">暂无简历</div>
          </div>
        </template>
        <template v-else>
          <div class="box-content">
            <div class="title">自我评价：</div>
            <div class="min-size">{{ detail.selfEval }}</div>
          </div>
          <div class="box-content">
            <p class="title">工作经历：</p>
            <div
              v-for="(item, index) in detail.userWorkExpList"
              :key="index"
            >
              <div class="flex-box2">
                <span style="margin-right: 40px; font-size: 16px">{{
                  item.companyName
                }}</span>
                <span>{{ item.startTime }} - {{ item.endTime }}</span>
              </div>
              <div class="flex-box2">
                <span class="min-size" style="margin-right: 30px">{{
                  item.industryTypeName
                }}</span>
                <span class="min-size" style="margin-right: 30px">{{
                  item.positionName
                }}</span>
                <span class="min-size" style="margin-right: 30px"
                  >{{ item.monthlyPay }}/月</span
                >
              </div>
              <div class="flex-box2">
                <span>技能：</span>
                <div
                  class="jn-item"
                  v-for="(items, indexs) in item.skillNameList"
                  :key="indexs"
                >
                  {{ items }}
                </div>
              </div>
              <div>
                <div>工作描述：</div>
                <div style="color: #666; margin: 10px 0">内容:</div>
                <div v-html="item.jobEsc" class="min-size"></div>
              </div>
            </div>
          </div>

          <div class="box-content">
            <div class="title">项目经历：</div>
            <div
              v-for="(item, index) in detail.userProjectExpList"
              :key="index"
            >
              <span class="min-size" style="margin-right: 20px">
                {{ item.projectName }}
              </span>
              <span class="min-size" style="margin-right: 20px">
                {{ item.positionName }}
              </span>
              <span class="min-size">
                {{ item.startTime }} ~ {{ item.endTime }}</span
              >
              <div class="min-size">内容：</div>
              <span class="min-size"> {{ item.projectContent }}</span>
            </div>
          </div>
          <div class="box-content">
            <p class="title">教育经历：</p>
            <div
              class="flex-box2"
              v-for="(items, indexs) in detail.userEducationExpList"
              :key="indexs"
            >
              <span style="margin-right: 30px; font-size: 16px">{{
                items.schoolName
              }}</span>
              <span style="margin-right: 30px; font-size: 16px">{{
                items.xlName
              }}</span>
              <span style="margin-right: 30px; font-size: 16px">{{
                items.subjectName
              }}</span>
              <span style="margin-right: 30px; font-size: 16px"
                >{{ items.startTime }} - {{ items.endTime }}</span
              >
            </div>
          </div>
          <div class="box-content">
            <div class="title">证书：</div>
            <div
              v-for="(item, index) in detail.userCertificateList"
              :key="index"
            >
              <span style="margin-right: 20px"> {{ item.name }} </span>
              <span style="margin-right: 20px"> {{ item.code }} </span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <dialogModel
      :visible.sync="dialogVisible"
      title="举报内容"
      @handleOk="handleOk"
    >
      <div style="padding: 20px; margin-left: 30px">
        <el-form
          :model="ruleForm"
          label-suffix="："
          label-position="top"
          :rules="rules"
          ref="ruleForm"
          label-width="1000px"
          class="demo-ruleForm"
        >
          <el-form-item label="举报内容" prop="textarea">
            <el-input
              :autosize="{ minRows: 4, maxRows: 10 }"
              type="textarea"
              placeholder="请输入至少10个字的举报内容"
              v-model="ruleForm.textarea"
              resize="none"
              maxlength="300"
              show-word-limit
              style="width: 600px"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="上传资料" prop="date">
            <zipUpload :key="uploadKey"></zipUpload>
          </el-form-item>
        </el-form>
      </div>
    </dialogModel>
    <Instruction
      :Credit="Credit"
      :Instruction="1"
      :dialogInstruction="dialogInstruction"
      @handleCloseInstruction="dialogInstruction = false"
      @handleInstruction="handleInstruction"
    ></Instruction>
  </div>
</template>

<script>
import {
  getPropCount, //获取道具剩余可用数量 Copy
  judgeCanFreeViewCreditEvaluation, //判断用不用消耗人才信用卡
} from "../../../../assets/api/firm/Opportunity";
import * as API from "@/assets/api/firm/firmRecruit.js";
import zipUpload from "@/components/zipUpload.vue";
import Instruction from "../components/Instruction.vue";
export default {
  components: { zipUpload, Instruction },
  data() {
    return {
      routeName: "",
      row: "",
      detail: "",
      dialogVisible: false,
      ruleForm: {
        textarea: "",
      },
      // 用于重置上传组件（zipUpload 不提供清空方法）
      uploadKey: 1,
      rules: {
        textarea: [
          { required: true, message: "请输入举报内容", trigger: "blur" },
          { min: 10, max: 300, message: "请最少输入10个字", trigger: "blur" },
        ],
      },
      rowObj: "",
      Credit: 0, //人才信用卡剩余数量
      dialogInstruction: false,
      isCollected: false,
      collectId: "",
    };
  },
  created() {
    this.row = JSON.parse(this.$route.query.row);
    this.viewEliteResume();
    this.getPropCountCredit();
  },
  computed: {
    /**
     * 判断简历是否为空：
     * - selfEval 无值
     * - userWorkExpList 为空数组/无
     * 两者都为空则展示“暂无简历”
     */
    hasSelfEval() {
      const v = this.detail && this.detail.selfEval;
      return v != null && String(v).trim() !== "";
    },
    hasUserWorkExpList() {
      const list = this.detail && this.detail.userWorkExpList;
      return Array.isArray(list) && list.length > 0;
    },
    showNoResume() {
      return !this.hasSelfEval && !this.hasUserWorkExpList;
    },
  },
  methods: {
    // 获取道具剩余可用数量
    getPropCountCredit() {
      getPropCount({ data: 2 })
        .then((res) => {
          if (res && res.data) {
            this.Credit = res.data.propCount;
          }
        })
        .catch((err) => {
          console.error("获取道具数量失败：", err);
        });
    },
    // 查看精英简历
    viewEliteResume() {
      let data = {
        data: {
          userId: this.row.id,
        },
      };
      API.viewEliteResume(data).then((res) => {
        this.detail = res.data;
        // hasCollect 即收藏记录 id：有值已收藏，无值未收藏
        const hasCollect = res.data && res.data.hasCollect;
        this.isCollected = !!hasCollect;
        this.collectId = hasCollect || "";
      });
    },
    // 收藏/取消收藏（与列表页逻辑保持一致）
    toggleCollect() {
      if (!this.$checkAction()) return;
      const intention =
        this.detail &&
        Array.isArray(this.detail.userJobIntentionList) &&
        this.detail.userJobIntentionList[0]
          ? this.detail.userJobIntentionList[0]
          : {};
      if (this.isCollected) {
        const id = this.collectId;
        if (!id) {
          this.$tool.PromptBox("warning", "缺少收藏记录，暂无法取消收藏");
          return;
        }
        this.$confirmWithScroll("是否取消该求职者收藏？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            API.cancelCollectElite({
              data: { ids: [id] },
            }).then((res) => {
              if (res.code === 0) {
                this.isCollected = false;
                this.collectId = "";
                this.$tool.PromptBox("success", "操作成功！");
              }
            });
          })
          .catch(() => {});
        return;
      }
      API.addCollectElite({
        data: {
          eliteId: this.row.id,
          hopeSalaryMin: intention.hopeMinSalary || "",
          hopeSalaryMax: intention.hopeMaxSalary || "",
        },
      }).then((res) => {
        if (res.code === 0) {
          this.$tool.PromptBox("success", "操作成功！");
          // 收藏后重新拉取简历，拿最新 hasCollect(收藏记录id)
          this.viewEliteResume();
        }
      });
    },
    // 前往信用评价
    goPj() {
      let data = {
        data: {
          userId: this.row.id,
        },
      };
      judgeCanFreeViewCreditEvaluation(data).then((res) => {
        if (res.code !== 0) return;
        if (res.data == false) {
          if (this.Credit > 0) {
            // 打开提示支付弹窗（由 Instruction 弹窗引导消耗）
            this.dialogInstruction = true;
          } else {
            // 无可用信用卡：先确认是否前往购买
            this.$confirmWithScroll("已无可用人才信用卡，是否前往购买信息卡？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.$router.push("/Firm/propHire");
              })
              .catch(() => {});
          }
          return;
        }

        // 关闭了消耗人才信用卡可直接进入查看
        // 业务接口本身会自己校验“是否有评价/是否还有可用信用卡”等，这里只负责把后端提示展示出来
        API.lookUserCreditEvaluationByUserId(data).then((lookRes) => {
          if (lookRes.code !== 0) {
            this.$tool.PromptBox(
              "warning",
              lookRes.data || lookRes.msg || lookRes.message || "查看信用评价失败"
            );
            return;
          }
          this.$router.push({
            path: "/Firm/recruitManager/evaluate",
            query: {
              res: JSON.stringify(lookRes),
              name: this.row.name,
            },
          });
        });
      });
    },
    // 确认支付道具卡查看/沟通
    handleInstruction() {
      //信用评价
      let data = {
        data: {
          userId: this.row.id,
        },
      };
      API.lookUserCreditEvaluationByUserId(data).then((res) => {
        if (res.code !== 0) {
          this.$tool.PromptBox(
            "warning",
            res.data || res.msg || res.message || "查看信用评价失败"
          );
          return;
        }
        this.$router.push({
          path: "/Firm/recruitManager/evaluate",
          query: {
            res: JSON.stringify(res),
            name: this.row.name,
          },
        });
      });
      this.dialogInstruction = false;
    },
    onJb(item) {
      this.dialogVisible = true;
      this.rowObj = item;
      localStorage.removeItem("docId");
      localStorage.removeItem("docName");
      localStorage.removeItem("TXurl");
      // 打开弹窗时清空举报内容
      this.ruleForm.textarea = "";
      // 重置上传组件内部状态
      this.uploadKey = Date.now();
    },
    // 举报确认
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = {
            data: {
              type: 4,
              sourceId: this.$store.getters.getCompany.id,
              sourceCode:
                this.$store.getters.getCompany.code ||
                this.$store.getters.getUser.code ||
                "",
              targetId: this.detail.id,
              sourceName: this.$store.getters.getCompany.name,
              targetName: this.detail.username,
              targetCode: this.detail.code,
              content: this.ruleForm.textarea,
              attachmentId: localStorage.getItem("docId"),
              attachmentName: localStorage.getItem("attachmentName"),
            },
          };
          API.report(data).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功！");
              this.dialogVisible = false;
              // 提交成功后清空举报内容/附件，避免下次打开仍残留
              this.resetReportDialog();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 清空举报弹窗状态（textarea + 上传附件）
    resetReportDialog() {
      this.ruleForm.textarea = "";
      try {
        this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
      } catch (e) {}
      localStorage.removeItem("docId");
      localStorage.removeItem("docName");
      localStorage.removeItem("TXurl");
      localStorage.removeItem("attachmentName");
      this.uploadKey = Date.now();
    },
    goBack() {
      const query = {};
      if (this.row) {
        // 与列表页权限过滤后的 tab 对齐，避免仅用数字 index 与可见 tab 错位
        if (this.row.tabVal) query.tab = this.row.tabVal;
        else if (this.row.name) query.tab = this.row.name;
        if (this.row.index != null && this.row.index !== "") {
          query.index = this.row.index;
        }
      }
      this.$router.push({
        path: "/Firm/recruitManager",
        query,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.ResumeContent {
  width: 1200px;
  min-height: 700px;
  box-sizing: border-box;
  overflow-y: auto;
  margin-top: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
  border-radius: 20px;
  padding: 30px;
  font-size: 14px;
  color: #333;

  .box-top {
    font-size: 14px;
    height: 100px;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #eeeeee;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;

    .left {
      .left-img {
        width: 60px;
        height: 60px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .left-text {
        margin-left: 20px;

        span {
          margin-right: 20px;
          font-size: 12px;
        }
      }
    }

    .center {
      img {
        width: 40px;
        margin: 0 10px;
      }
    }

    .right {
      display: flex;

      .right-button {
        width: 120px;
        margin: 0 15px;
        box-sizing: border-box;
        height: 35px;
        line-height: 35px;
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        background-color: #409eff ;
        text-align: center;
        color: #fff;
        font-size: 14px;
        cursor: pointer;

        img {
          width: 20px;
        }
      }
    }
  }

  .text-content {
    margin: 20px 0 0 40px;

    .no-resume-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 60px 0;
    }

    .no-resume-text {
      margin-top: 12px;
      font-size: 14px;
      color: #999;
    }

    .box-content {
      margin-top: 30px;
      font-size: 14px;

      .title {
        font-size: 16px;
        margin: 20px 0;
      }

      .flex-box2 {
        margin: 20px 0;

        .jn-item {
          display: inline-block;
          background-color: #eee;
          margin: 0 10px;
          color: #333;
          padding: 5px;
          border-radius: 5px;
        }
      }
    }
  }
}
</style>
